SlideView = require "views/slide"

class MediaCollectionView extends SlideView
  template: require("./template")
  fitTextOnResize: false
  fitTextOnRender: false

  events: ->
    {
      "iostap .btn-done": "submit"
      "iostap .details-parent": "hideDetails"
      "iostap .tappy": "toggleContent"
    }
  
  serialize: ->
    data = super()
    data.tappies = data.content || []
    data.hasPrompt = true
    data

  show: ->
    @setEl @findOne(".tappies"), "tappies"
    @setEl @findAll(".details"), "details"

    @onResize()

    @listenTo this, "resize", @onResize
    @toVisit = [0...@serialize().tappies.length]
    @hideDetails()

  resetPlayer: (player) ->
     window.setTimeout (-> player.hasStarted(false)), 1

  onResize: ->
    title = $(".title")
    contentContainer = $(".content-container")
    detailsParent = $(".details-parent")
    tappiesParent = $(".tappies-parent")

    length = @getEl("tappies").children.length
    length = Math.ceil(length / 2) if length >= 4

    outerHeight = contentContainer.height() - title.height()
    tappyHeight = outerHeight / length
    tappyHeight = Math.min(tappyHeight, 220)

    for el, i in @getEl("tappies").children
      $(el).height(tappyHeight)

    $(".tappy-overlay").height($(".tappy-child").height())

  onDetailResize: -> 
    details = @getEl("active-details")
    @limitDetailImageSize(details)

  showDetails: (tappy, animate) =>
    index = +tappy.dataset.index
    contentType = @getContentType(index)
    details = @getEl("details").item(index)

    @toVisit = _.without @toVisit, index

    @setEl details, "active-details"

    @setState("touched") if _.isEmpty(@toVisit)
    @setState("active", "details")

    @listenTo this, "resize", @onDetailResize
    @onDetailResize()

    $(details).css({
      opacity: 1
      "z-index": 1000
      transform: if animate then "translate(-50%, -50%) scale(1)" else ""
    })

    @playDetailsMedia(contentType, details)

    tappy.classList.add("visited")

  limitDetailImageSize: (details) ->
    detailsParent = $(".details-parent")
    fullSizeImage = details.querySelector(".full-size")
    caption = details.querySelector(".caption")

    availableHeightForImage = detailsParent.height() - caption.offsetHeight

    video = fullSizeImage.querySelector("video")

    fullSizeImage.style.maxHeight="#{availableHeightForImage}px"
    
    if video and video.offsetHeight > availableHeightForImage
      $(fullSizeImage).css("padding-top", availableHeightForImage)
    else if fullSizeImage.offsetHeight > availableHeightForImage
      $(fullSizeImage).height(availableHeightForImage)

  toggleContent: (e) ->
    @showDetails e.currentTarget, true
  
  playDetailsMedia: (contentType, details) =>
    # Slide.coffee already instantiates all videoJS players on the slide
    # so we find the instance that was created for the clicked video
    if contentType is "video"
      window.setTimeout (=>
        videoJsPlayer = details.querySelector("div.video-js")
        if videoJsPlayer
          id = videoJsPlayer.getAttribute("id")
          @activePlayer = _.findWhere(@players, { id_: id })
          @activePlayer.play()
        ), 400
    else if contentType is "audio"
      window.setTimeout (->
        audioPlayer = details.querySelector("audio")
        audioPlayer.play() if audioPlayer
      ), 400

  hideDetails: (e) ->
    # may be called with or without a user gesture event
    if e?
      # prevent hiding of details if interacting with videoJS element
      return if /vjs/.test(e.target.className) or e.target.nodeName is "VIDEO"
      # prevent hiding of details if interacting with audio element
      return if e.target.nodeName is "AUDIO"

    return unless details = @getEl("active-details")

    @stopDetailsMedia(details)

    $(details).css({
      opacity: 0
      "z-index": 0
      transform: "translate(-50%, -50%) scale(0.9)"
    })

    @setState("inactive", "details")
  
  stopDetailsMedia: (details) ->
    # stop audio if any exists on this details element
    audioEl = details.querySelector("audio")
    audioEl.pause() if audioEl?
    # stops videoJS playback from SlideView
    @stopMedia()

  getContentType: (index) ->
    @options.data.content[index].contentType or "video"

  refresh: (params) ->
    if params.data.content and @options.data.content and params.data.content.length is @options.data.content.length
      for { content, caption }, i in params.data.content
        if content and \
        @options.data.content[i]?.content isnt content or \
        @options.data.content[i]?.caption isnt caption
          itemChangedIdx = i

    super(params)

    if itemChangedIdx? and tappy = @getEl("tappies").children[itemChangedIdx]
      @showDetails(tappy, false)

module.exports = MediaCollectionView
